export default "__VITE_ASSET__Dq_E8J06__"